import React from 'react';
import { TextField } from '@mui/material';

const CustomTextField = (props) => {
  return <TextField {...props} size="small" />;
};

export default CustomTextField;